/* assets/section-orsa-nav.js
   ORSA — overlays + cart overlay (AJAX via sections rendering)
*/

(() => {
  const nav = document.querySelector("[data-orsa-nav]");
  if (!nav) return;

  const html = document.documentElement;
  const body = document.body;

  /* ---------------------------
     Overlay helpers
  ----------------------------*/
  const main = {
    wrap: nav.querySelector("[data-orsa-overlay]"),
    open: nav.querySelector("[data-orsa-open]"),
    close: nav.querySelector("[data-orsa-close]"),
    closeOnAnyLink: true,
  };

  // ✅ Shop overlay: single-unit triggers only
  const shop = {
    wrap: nav.querySelector("[data-orsa-shop-overlay]"),
    opens: Array.from(nav.querySelectorAll("[data-orsa-shop-toggle]")),
    close: nav.querySelector("[data-orsa-shop-close]"),
    closeOnAnyLink: true,
  };

  const sort = {
    wrap: nav.querySelector("[data-orsa-sort-overlay]"),
    open: nav.querySelector("[data-orsa-sort-open]"),
    close: nav.querySelector("[data-orsa-sort-close]"),
    closeOnAnyLink: false,
  };

  const cart = {
    wrap: nav.querySelector("[data-orsa-cart-overlay]"),
    open: nav.querySelector("[data-orsa-cart-open]"),
    close: nav.querySelector("[data-orsa-cart-close]"),
    closeOnAnyLink: false,
  };

  const hasOpen = (g) => !!(g.open || (g.opens && g.opens.length));
  const groups = [main, shop, sort, cart].filter((g) => g.wrap && hasOpen(g) && g.close);

  const isOpen = (g) => g.wrap.classList.contains("is-open");

  const updateLock = () => {
    const anyOpen = groups.some(isOpen);
    html.classList.toggle("orsa-lock", anyOpen);
    body.classList.toggle("orsa-lock", anyOpen);
  };

  const setExpanded = (g, expanded) => {
    const val = expanded ? "true" : "false";

    if (g.open) g.open.setAttribute("aria-expanded", val);
    if (g.opens?.length) g.opens.forEach((btn) => btn.setAttribute("aria-expanded", val));

    // Update +/- only if the trigger contains the symbol span
    if (g === shop && g.opens?.length) {
      g.opens.forEach((btn) => {
        const sym = btn.querySelector("[data-orsa-shop-symbol]");
        if (sym) sym.textContent = expanded ? "−" : "+";
      });
    }
  };

const closeGroup = (g) => {
  if (!isOpen(g)) return;
  g.wrap.classList.remove("is-open");
  g.wrap.setAttribute("aria-hidden", "true");
  setExpanded(g, false);

  if (g === cart) body.classList.remove("orsa-cartOpen");

  updateLock();
};


  const closeAllExcept = (keep) => {
    groups.forEach((g) => {
      if (g !== keep) closeGroup(g);
    });
  };

const openGroup = (g) => {
  closeAllExcept(g);
  if (isOpen(g)) return;
  g.wrap.classList.add("is-open");
  g.wrap.setAttribute("aria-hidden", "false");
  setExpanded(g, true);

  if (g === cart) body.classList.add("orsa-cartOpen");

  updateLock();
  g.close?.focus?.({ preventScroll: true });
};
  const bindOverlay = (g) => {
    if (g.open) g.open.addEventListener("click", () => openGroup(g));
    g.close.addEventListener("click", () => closeGroup(g));

    g.wrap.addEventListener("mousedown", (e) => {
      const panel = e.target.closest(".orsa-nav__panel");
      if (!panel) closeGroup(g);
    });

    if (g.closeOnAnyLink) {
      g.wrap.addEventListener("click", (e) => {
        const a = e.target.closest("a");
        if (a) closeGroup(g);
      });
    }
  };

  groups.forEach(bindOverlay);

  // ✅ Shop triggers toggle behavior (Shop All + / Coffee +) as ONE unit
  if (shop.opens?.length) {
    shop.opens.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (isOpen(shop)) closeGroup(shop);
        else openGroup(shop);
      });
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    groups.forEach(closeGroup);
  });

  /* ---------------------------
     Sort overlay logic (unchanged)
  ----------------------------*/
  function setSortLabel(label) {
    const labelEl = nav.querySelector("[data-orsa-sortLabel]");
    if (labelEl) labelEl.textContent = label;
  }

  function updateUrlSort(sortBy) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sortBy);
    url.searchParams.delete("page");
    history.replaceState({}, "", url.toString());
  }

  nav.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-sort]");
    if (!btn) return;

    const value = btn.getAttribute("data-sort") || "manual";
    const label = (btn.textContent || "").trim() || "Recommended";

    setSortLabel(label);
    groups.forEach(closeGroup);
    updateUrlSort(value);

    if (window.ORSA_SHOP && typeof window.ORSA_SHOP.applySort === "function") {
      window.ORSA_SHOP.applySort(value);
      return;
    }

    window.location.reload();
  });

  (() => {
    const sortBy = new URL(window.location.href).searchParams.get("sort_by");
    if (!sortBy) return;

    const map = {
      manual: "Recommended",
      "created-descending": "New Arrivals",
      "price-ascending": "Price: Low to High",
      "price-descending": "Price: High to Low",
    };

    if (map[sortBy]) setSortLabel(map[sortBy]);
  })();

  /* ---------------------------
     CART overlay (AJAX via section render)
  ----------------------------*/
  const SECTION_ID = "orsa-cart-overlay";

  const clampQty = (n) => {
    const v = Number(n);
    if (!Number.isFinite(v)) return 0;
    return Math.max(0, Math.floor(v));
  };

  function getCartOverlayRoot() {
    return nav.querySelector("[data-orsa-cart-overlay]");
  }

  function setCartBusy(isBusy) {
    const root = getCartOverlayRoot();
    if (!root) return;
    root.classList.toggle("is-busy", !!isBusy);
    const panel = root.querySelector(".orsa-cart__panel");
    if (panel) panel.setAttribute("aria-busy", isBusy ? "true" : "false");
  }

  async function postJson(url, payload) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`${url} failed`);
    return res.json();
  }

  async function fetchSectionHTML() {
    const res = await fetch(`${window.location.pathname}?sections=${SECTION_ID}`, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!res.ok) throw new Error("Section fetch failed");
    const json = await res.json();
    return json[SECTION_ID];
  }

  function patchCartOverlayFromHTML(html) {
  const root = getCartOverlayRoot();
  if (!root) return;

  const tmp = document.createElement("div");
  tmp.innerHTML = html;

  const nextRoot = tmp.querySelector("[data-orsa-cart-overlay]");
  if (!nextRoot) throw new Error("Rendered cart overlay missing");

  const nextCount = nextRoot.querySelector("[data-orsa-cart-count]");
  const nextTotal = nextRoot.querySelector("[data-orsa-cart-total]");
  const nextBody = nextRoot.querySelector("[data-orsa-cart-body]");

  const curCount = root.querySelector("[data-orsa-cart-count]");
  const curTotal = root.querySelector("[data-orsa-cart-total]");
  const curBody = root.querySelector("[data-orsa-cart-body]");

  if (curCount && nextCount) curCount.textContent = nextCount.textContent;
  if (curTotal && nextTotal) curTotal.innerHTML = nextTotal.innerHTML;
  if (curBody && nextBody) curBody.innerHTML = nextBody.innerHTML;

  const headerCount = nav.querySelector("[data-orsa-header-cart-count]");

  if (headerCount && nextCount) {
    const value = (nextCount.textContent || "0").trim();

    headerCount.textContent = value;
    headerCount.classList.toggle("is-empty", value === "0");
  }
}

  async function refreshCartOverlay() {
    const html = await fetchSectionHTML();
    patchCartOverlayFromHTML(html);
  }

  async function addToCart(formEl) {
    const fd = new FormData(formEl);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
      const msg = (data && (data.description || data.message)) || "Add to cart failed";
      throw new Error(msg);
    }

    return data;
  }

  async function changeLine(line, quantity) {
    await postJson("/cart/change.js", { line, quantity });
    await refreshCartOverlay();
  }

  // refresh once on open
  cart.open?.addEventListener("click", () => {
    window.setTimeout(() => {
      refreshCartOverlay().catch(console.error);
    }, 50);
  });

  /* Intercept add-to-cart */
  document.addEventListener(
    "submit",
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute("action") || "").toLowerCase();
      const isAddAction = action.startsWith("/cart/add") || action.includes("/cart/add");
      const isOrsaForm = form.hasAttribute("data-orsa-product-form");

      if (!isAddAction && !isOrsaForm) return;

      e.preventDefault();

      const wasOpen = cart.wrap?.classList.contains("is-open");

      try {
        setCartBusy(true);
        await addToCart(form);
        await refreshCartOverlay();
        if (!wasOpen) openGroup(cart);
      } catch (err) {
        console.error(err);
      } finally {
        setCartBusy(false);
      }
    },
    true
  );

  /* Cart interactions */
  nav.addEventListener("click", async (e) => {
    const root = getCartOverlayRoot();
    if (!root) return;
    if (!e.target.closest("[data-orsa-cart-overlay]")) return;

    const removeBtn = e.target.closest("[data-orsa-remove]");
    if (removeBtn) {
      e.preventDefault();
      const line = Number(
        removeBtn.getAttribute("data-line") ||
          removeBtn.closest("[data-line]")?.getAttribute("data-line")
      );
      if (!line) return;

      try {
        setCartBusy(true);
        await changeLine(line, 0);
      } catch (err) {
        console.error(err);
        refreshCartOverlay().catch(console.error);
      } finally {
        setCartBusy(false);
      }
      return;
    }

    const qtyBtn = e.target.closest("[data-orsa-cart-qty]");
    if (!qtyBtn) return;

    e.preventDefault();

    const line = Number(
      qtyBtn.getAttribute("data-line") || qtyBtn.closest("[data-line]")?.getAttribute("data-line")
    );
    if (!line) return;

    const row = root.querySelector(`[data-line="${line}"]`);
    const input =
      row?.querySelector(`[data-orsa-cart-qty-input][data-line="${line}"]`) ||
      row?.querySelector("[data-orsa-cart-qty-input]");
    if (!input) return;

    const current = clampQty(input.value);
    const dir = qtyBtn.getAttribute("data-orsa-cart-qty");
    const next = dir === "plus" ? current + 1 : current - 1;

    input.value = String(Math.max(0, next));

    try {
      setCartBusy(true);
      await changeLine(line, Math.max(0, next));
    } catch (err) {
      console.error(err);
      refreshCartOverlay().catch(console.error);
    } finally {
      setCartBusy(false);
    }
  });

  nav.addEventListener("change", async (e) => {
    const root = getCartOverlayRoot();
    if (!root) return;

    const input = e.target.closest("[data-orsa-cart-qty-input]");
    if (!input) return;
    if (!e.target.closest("[data-orsa-cart-overlay]")) return;

    const line = Number(input.getAttribute("data-line") || input.closest("[data-line]")?.getAttribute("data-line"));
    if (!line) return;

    const next = clampQty(input.value);

    try {
      setCartBusy(true);
      await changeLine(line, next);
    } catch (err) {
      console.error(err);
      refreshCartOverlay().catch(console.error);
    } finally {
      setCartBusy(false);
    }
  });
})();